import * as React from 'react';
import './feature_image_wide_block.css'

export interface FeatureImageWideBlock_Props {
    title: string;
    body: string;
    body2: string;
    image: string;
}

class FeatureImageWideBlock extends React.PureComponent<FeatureImageWideBlock_Props> {

    constructor(props: FeatureImageWideBlock_Props) {
        super(props)
    }

    render() {
        return (
            <div className="feature-wide-block main-feature-wide-spacing main-back-color main-shadow">
                <div className="feature-wide-contents main-text-center">
                    <div className="feature-wide-image-title">
                        <h2 className="main-cta-title">{this.props.title}</h2>
                    </div>
                    <div className="feature-wide-image-body">
                        <div className="feature-wide-image-body-text">
                            <h3 className="main-cta-sub-title">{this.props.body}</h3>
                            <h3 className="main-cta-sub-title">{this.props.body2}</h3>
                        </div>
                    </div>
                    <div className="feature-wide-image-img">
                        <div className="feature-wide-image-body-img">
                            <img src={this.props.image} className="feature-wide-image-img main-shadow" alt={this.props.title} />
                        </div>
                    </div>
                </div>  
            </div>
        )
    }
}

export default FeatureImageWideBlock;


// WEBPACK FOOTER //
// ./src/custom_components/feature_image_wide_block/feature_image_wide_block.component.tsx